import $ from "jquery";
window.$ = window.jQuery = $;

export const burgerMenuClose = () => {
	(($) => {
		$(".ubermenu .btn-close").click(() => {
			$(".ubermenu").addClass("ubermenu-responsive-collapse");
			$(".ubermenu-responsive-toggle").removeClass("ubermenu-responsive-toggle-open");
		});

		$(document).click((e) => {
			if($(e.target).is(".wpml-ls-native") === false) {
				$(".ubermenu").addClass("ubermenu-responsive-collapse");
				$(".ubermenu-responsive-toggle").removeClass("ubermenu-responsive-toggle-open");
			}
		});
	})(jQuery);
};

export const backToTop = () => {
	(($) => {
		const win = $(window);

		win.scroll(() => {
			if (win.scrollTop() > 100) {
				$(".btn-to-top").addClass("show");
			} else {
				$(".btn-to-top").removeClass("show");
			}
		});

		$(".btn-to-top").click(() => {
			$("html, body").animate({ scrollTop: 0 });
		});
	})(jQuery);
};

export const articleBackButton = () => {
	(($) => {
		if ($("body").hasClass("single-post")) {
			$(".js-back").on("click", function (evt) {
				if (document.referrer.indexOf(window.location.host) !== -1) {
					evt.preventDefault();
					history.back();
				}
			});
		}
	})(jQuery);
};
